export const SCHEDULE_IMPORT_STATUS_OPTIONS = [
    { value: "DRAFT", label: "草稿" },
    { value: "SUBMITTED", label: "已提交" },
    { value: "AIRLINE_CONFIRMED", label: "已确认" },
    { value: "PUBLISHED", label: "已发布" },
];

const SCHEDULE_IMPORT_STATUS_LABELS = Object.fromEntries(SCHEDULE_IMPORT_STATUS_OPTIONS.map((option) => [option.value, option.label]));

export function buildScheduleImportQueryParams({ search, limit, statuses = [], aircraftReg } = {}) {
    const params = {};
    const normalizedSearch = typeof search === "string" ? search.trim() : "";
    const normalizedAircraftReg = typeof aircraftReg === "string" ? aircraftReg.trim() : "";

    if (normalizedSearch) params.search = normalizedSearch;
    if (limit) params.limit = limit;
    if (Array.isArray(statuses) && statuses.length > 0) params.status = statuses.join(",");
    if (normalizedAircraftReg) params.aircraft_reg = normalizedAircraftReg;

    return params;
}

export function getScheduleImportStatusLabel(status) {
    return SCHEDULE_IMPORT_STATUS_LABELS[status] || status || "状态未知";
}
